export default __webpack_public_path__ + "media/images/home/living_utilities-0caacb31763710a8084ff20c3706cadd.png";